// Google Tag Manager & Google Ads Conversion Tracking utility

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    gtag: (...args: unknown[]) => void;
  }
}

// Google Ads Conversion IDs - Replace with your actual values from Google Ads
// You can find these in Google Ads > Tools > Conversions > Your Conversion > Tag setup
const GOOGLE_ADS_CONVERSION_ID = 'AW-XXXXXXXXXX'; // Replace with your Google Ads Conversion ID

// Conversion labels for different actions
const CONVERSION_LABELS = {
  contact_form: 'XXXXXXXXXX', // Replace with your contact form conversion label
  phone_click: 'XXXXXXXXXX',  // Replace with your phone click conversion label
  whatsapp_click: 'XXXXXXXXXX', // Replace with your WhatsApp click conversion label
};

type EventParams = {
  event: string;
  [key: string]: unknown;
};

export const trackEvent = (params: EventParams) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(params);
  }
};

// Pre-defined events for common actions
export const trackFormSubmission = (formName: string, additionalData?: Record<string, unknown>) => {
  trackEvent({
    event: 'form_submission',
    form_name: formName,
    ...additionalData,
  });
};

export const trackButtonClick = (buttonName: string, location?: string) => {
  trackEvent({
    event: 'button_click',
    button_name: buttonName,
    click_location: location,
  });
};

export const trackPageView = (pageName: string, pageUrl?: string) => {
  trackEvent({
    event: 'page_view',
    page_name: pageName,
    page_url: pageUrl || window.location.pathname,
  });
};

export const trackServiceInquiry = (serviceName: string) => {
  trackEvent({
    event: 'service_inquiry',
    service_name: serviceName,
  });
};

export const trackJobApplication = (jobTitle: string) => {
  trackEvent({
    event: 'job_application',
    job_title: jobTitle,
  });
};

// ============ Google Ads Conversion Tracking ============

// Track Google Ads conversion
export const trackGoogleAdsConversion = (conversionLabel: string, value?: number, currency?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': `${GOOGLE_ADS_CONVERSION_ID}/${conversionLabel}`,
      'value': value || 0,
      'currency': currency || 'USD',
    });
  }
  
  // Also push to dataLayer for GTM
  trackEvent({
    event: 'google_ads_conversion',
    conversion_label: conversionLabel,
    value: value,
    currency: currency,
  });
};

// Track contact form submission as conversion
export const trackContactFormConversion = (formData?: { subject?: string }) => {
  trackGoogleAdsConversion(CONVERSION_LABELS.contact_form);
  trackFormSubmission('contact_form', formData);
  
  console.log('📊 Contact form conversion tracked');
};

// Track phone click as conversion
export const trackPhoneClickConversion = (phoneNumber: string, location?: string) => {
  trackGoogleAdsConversion(CONVERSION_LABELS.phone_click);
  trackEvent({
    event: 'phone_click',
    phone_number: phoneNumber,
    click_location: location,
  });
  
  console.log('📊 Phone click conversion tracked:', phoneNumber);
};

// Track WhatsApp click as conversion
export const trackWhatsAppClickConversion = (phoneNumber: string, location?: string) => {
  trackGoogleAdsConversion(CONVERSION_LABELS.whatsapp_click);
  trackEvent({
    event: 'whatsapp_click',
    phone_number: phoneNumber,
    click_location: location,
  });
  
  console.log('📊 WhatsApp click conversion tracked:', phoneNumber);
};
